import { render, staticRenderFns } from "./DialogsContainer.vue?vue&type=template&id=3f6c6671&"
import script from "./DialogsContainer.vue?vue&type=script&lang=ts&"
export * from "./DialogsContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports